// extracted by mini-css-extract-plugin
module.exports = {"card":"FooterPlatforms_card__1MduF","container":"FooterPlatforms_container__3_JXJ","item":"FooterPlatforms_item__3Ajck","card_caption":"FooterPlatforms_card_caption__3juV4"};